import React, { JSX } from 'react'
import Box from '@mui/material/Box'

export const FullHeightBox = ({ children }: { children: string | JSX.Element | JSX.Element[] }) => {
    return (
        <Box display='flex' sx={{ height: '100%', alignItems: 'center' }}>
            {children}
        </Box>
    )
}
